import { AxiosResponse } from "axios";
import _ from "lodash";
import { IResponseResult } from "@/services/data/base_types";
import base_ds from "@/services/base_datasource_service";
import { Tariff } from "@/services/models-service";
import request from "@/utils/request";


export const route_ns = `tariff`;

interface ICachedTariffs {
  [key: string]: Tariff[];
}

class TariffService {
    public current: Tariff | null = null;
    public crud = base_ds.getBaseCrud(route_ns);
    public data_source = base_ds.getBaseDataSource(route_ns);

    // Презагруженные связки id срезки - тарифы хранятся здесь, при изменении id узла обновляются полностью
    // или же частично добавляются срезки при выборе новых срезок
    public preloadedTariffsEcoNodeId: null | number = null;
    private cachedTariffs: ICachedTariffs = {};

    public setCurrent(value: Tariff) {
      this.current = value;
    }

    public async save(entitys: Tariff[]): Promise<IResponseResult<Tariff>> {
      const response: AxiosResponse["data"] = await request({
        url: route_ns,
        method: "post",
        data: {data: entitys},
      });
      if (response) {
        return { data: response.data as Tariff };
      } else {
        return { data: null, message: "" };
      }
    }

    public async get(): Promise<IResponseResult<Tariff[]>> {
      const response: AxiosResponse["data"] = await this.crud.get();
      if (response && response.data) {
        return {data: response.data as Tariff[] };
      } else {
        return { data: null, message: "" };
      }
    }

    public async getById(entity: string): Promise<IResponseResult<Tariff>> {
      const response: AxiosResponse["data"] = await this.crud.get_by_id(entity);
      if (response) {
        return response;
      } else {
        return { data: null, message: "" };
      }
    }

    public async getWithFilter(id_cut: string, id_node: number): Promise<IResponseResult<Tariff[]>> {
        const route = route_ns+`?filter=[["id_cut","=","${id_cut}"],"and",["id_eco_heat_node","=","${id_node}"]]`;
        const response: AxiosResponse["data"] = await request({
            url: route,
            method: "get",
          });
        if (response) {
          return response;
        } else {
          return { data: null };
        }
      }

    public async getFew(ids: string[], id_node: number): Promise<IResponseResult<ICachedTariffs>> {
      let cuts_to_load = []; // итоговый список Id срезок для загрузки тарифов, может отличаться от заданного в параметре ids
      if (id_node !== this.preloadedTariffsEcoNodeId) {
        cuts_to_load = ids;
        this.cachedTariffs = {};
        this.preloadedTariffsEcoNodeId = id_node;
      } else {
        // Если тарифы для срезки уже загружены, не загружаем их заного
        cuts_to_load = ids.filter( cid => !this.cachedTariffs.hasOwnProperty(cid))
      }

      if (cuts_to_load.length) {
        const route = route_ns+`/few_cut?filter=[["id_cut","in",${JSON.stringify(cuts_to_load)}],"and",["id_eco_heat_node","=","${id_node}"]]`;
        const response: AxiosResponse["data"] = await request({
          url: route,
          method: "get",
        });
        if (response.data) {
          // объеденить объекты по ранее загруженным срезкам и новые
          this.cachedTariffs = { ...this.cachedTariffs, ...response.data };
        }
      }

      return { data: this.cachedTariffs };
    }

    public async indexData(data: any) {
      const route = route_ns+`/index`;
      const response: AxiosResponse["data"] = await request({
          url: route,
          method: "post",
          data: data,
          timeout: 120000,
        });
      if (response) {
        return response;
      } else {
        return { data: null }
      }
    }

    public async filtrationData(filter: any): Promise<IResponseResult<Tariff[]>> {
      const route = route_ns+`?filter=${filter}`;
      const response: AxiosResponse["data"] = await request({
          url: route,
          method: "get",
        });
      if (response) {
        return response;
      } else {
        return { data: null };
      }
    }


      public async delete(entitys: Tariff[]) {
        const response: AxiosResponse["data"] = await request({
          url: route_ns,
          method: "delete",
          data: {data: entitys},
        });
      }

  }

  export default new TariffService();
